import { jsonldAggregateRatingCount } from './JsonldStore';

export const updateJsonldAggregateRatingCount = (value) => jsonldAggregateRatingCount.update((oldValue) => value);
